
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class AbmImgSanitizerService {

    constructor(
        private _sanitizer: DomSanitizer,
    ) { }

    public getSafeImgUrl(imgPath: string) {
        if (!imgPath) {
            throw new Error('Cannot get image of ' + imgPath);
        }

        return this._sanitizer.bypassSecurityTrustStyle(`url(${imgPath})`);
    }

}
